<template>
  <el-collapse v-model="expanded">
    <el-collapse-item
      v-for="v in versions"
      :key="v.id"
      :name="v.id">

      <template #title>
        <div class="rvh-summary">
          <span class="rvh-vno">v{{ v.version_no }}</span>
          <el-tag
            v-if="v.is_current"
            type="success"
            size="mini"
            effect="dark">
            <i class="fa fa-check"></i> Current
          </el-tag>
          <el-tag
            v-else
            type="info"
            size="mini">
            <i class="fa fa-history"></i> Superseded
          </el-tag>
          <span class="rvh-meta">Published {{ formatDate(v.published_at) }}</span>
          <span class="rvh-pinned">
            <i class="fa fa-thumb-tack"></i>
            {{ v.pinned_count }} {{ v.pinned_count === 1 ? 'site' : 'sites' }} pinned
          </span>
        </div>
      </template>

      <rate-tiers-cell :row-data="{ tiers: v.tiers }" :hide-drawer-affordance="true" />

    </el-collapse-item>
  </el-collapse>
</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import RateTiersCell from './RateTiersCell'

export default {
  name: 'rate-version-history',

  mixins: [DateMixins],

  components: {
    RateTiersCell
  },

  props: {
    versions: {
      type: Array,
      default: function () { return [] }
    }
  },

  data: function () {
    return {
      expanded: []
    }
  },

  watch: {
    versions: function (newVersions) {
      this.expandCurrent(newVersions)
    }
  },

  mounted: function () {
    this.expandCurrent(this.versions)
  },

  methods: {
    expandCurrent: function (versions) {
      var current = versions.find(function (v) { return v.is_current })
      if (current) {
        this.expanded = [current.id]
      }
    }
  }
}
</script>

<style scoped>
.rvh-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}

.rvh-vno {
  font-weight: 700;
  font-size: 14px;
}

.rvh-meta {
  color: #909399;
  font-size: 12px;
}

.rvh-pinned {
  color: #606266;
  font-size: 12px;
}
</style>
